import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { PHOTO_REVIEW_UISTATE } from '../../model/photo-review.constant';
import { PhotoUtilsService } from '../../service/photo-review-utils.service';
import { GalleryOptions } from '@cv-invision/cv.component-library.ux';
@Component({
	selector: 'cv-photo-content-exterior',
	templateUrl: './photo-content-exterior.component.html',
	styleUrls: ['../photo-content-detail.component.scss']
})
export class PhotoContentExteriorComponent implements OnInit, OnChanges {
	deficiencies: any;
	features: any;
	updates: any;
	mechanical: any;
	noInfo = PHOTO_REVIEW_UISTATE.NO_INFO;
	@Input() info: any;
	@Input() galleryOptions: any;

	options: GalleryOptions = {
		hasSelected : false,
		showDescription: false,
		noFilesImage: 'assets/img/placeholder/nofiles.png',
		size: {
			width: '100%',
			height: '225px'
		}
	}

	constructor(private photoUtils: PhotoUtilsService) {}

	/**
   * loop into the cv_photos for each extra info related to exteriors
   * @param item
   */
	setgalleryPath(item: any): void {
		item.forEach(e => {
			if (e.cv_photos) {
				e.cv_photos = this.photoUtils.setGalleryPhotosInfo(e.cv_photos);
			}
		});
	}

	/**
   * Set information for  lifecycle hooks
   */
	setInfoExterior(): void {
		const {
			exteriorDeficiencies,
			exteriorFeatures,
			exteriorUpdates,
			mechanicalDeficiencies
		} = this.info;
		this.deficiencies = exteriorDeficiencies;
		this.features = exteriorFeatures;
		this.updates = exteriorUpdates;
		this.mechanical = mechanicalDeficiencies;
		if (this.deficiencies) {
			this.setgalleryPath(this.deficiencies);
		}
		if (this.features) {
			this.setgalleryPath(this.features);
		}
		if (this.updates) {
			this.setgalleryPath(this.updates);
		}
		if (this.mechanical) {
			this.setgalleryPath(this.mechanical);
		}
	}

	ngOnChanges(): void {
		if (this.info) {
			this.setInfoExterior();
		}
	}

	ngOnInit(): void {
		this.setInfoExterior();
	}
}
